import { useCallback, useRef } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { MaskedTextField } from '../text-field/masked-text-field';

export type EditMaskedCellProps = GridRenderCellParams & { mask: string };

export const DataGridEditMaskedField = ({
  id,
  field,
  value,
  api,
  mask,
}: EditMaskedCellProps) => {
  const initialValue = useRef<string>(value ?? '');
  const currentValue = useRef<string>(value ?? '');

  const handleChange = useCallback(
    (maskedValue: string) => {
      currentValue.current = maskedValue;
      api.setEditCellValue({ id, field, value: maskedValue });
    },
    [api, id, field]
  );

  const handleBlur = useCallback(() => {
    const val = currentValue.current;
    if (val && val.length !== mask.length) {
      api.setEditCellValue({ id, field, value: initialValue.current });
    }
    api.stopCellEditMode({ id, field });
  }, [api, id, field, mask]);

  return (
    <MaskedTextField
      mask={mask}
      value={value ?? ''}
      autoFocus
      fullWidth
      variant="standard"
      onChange={handleChange}
      onBlur={handleBlur}
      slotProps={{ input: { disableUnderline: true } }}
    />
  );
};
